function doSearch(): void {
	try {
		const searchString: string = (<HTMLFormElement>document.getElementById('OCForm1')).searchUI_tbProductName.value
		const cleanedSearchString: string = searchString.replace('(', '').replace(')', '')
		const searchInput = document.getElementById('searchUI_tbProductName')
		if (searchString !== '' && searchString !== 'I\'m looking for...') {
			const searchButton = $("#btn_Search-Search")
			searchButton.text("").addClass("loader-light")
			const encodedSearchString: string = encodeURIComponent(cleanedSearchString)
			window.location.href = `search.aspx?&posting=TRUE&actionType=CUSTOMSEARCH&customSearchParams=KEYWORDS|${encodedSearchString}&customSearchParamsSearchString=${encodedSearchString}&from=QUICKSEARCH`
		} else {
			const inputControl = searchInput.parentElement
			const errorDisplay = inputControl.querySelector('.error') as HTMLElement
			errorDisplay.innerText = 'Please enter a product name'
			inputControl.classList.add('error')
		}
	} catch (e) { }
}

function doQuickSearch(searchPath: string): void {
	try {
		const pageSize: number = 27
		const searchString: string = (<HTMLFormElement>document.getElementById('OCForm1')).tSearchString.value
		const cleanedSearchString: string = searchString.replace(/[\(\)']/g, '') // Use a regular expression to replace all '(', ')', and "'" characters.
		const searchInput = document.getElementById('tSearchString')
		if (searchString !== '') {
			const searchButton = $("#searchSubmit")
			searchButton.text("").addClass("loader-light")
			const encodedSearchString: string = encodeURIComponent(cleanedSearchString)
			window.location.href = `${searchPath}search.aspx?&posting=TRUE&actionType=CUSTOMSEARCH&customSearchParams=KEYWORDS|${encodedSearchString}&customSearchParamsSearchString=${encodedSearchString}&from=QUICKSEARCH&pageSize=${pageSize}`
		} else {
			const inputControl = searchInput.parentElement
			const errorDisplay = inputControl.querySelector('.error') as HTMLElement
			errorDisplay.innerText = 'Please enter a product name'
			inputControl.classList.add('error')
		}
	} catch (e) { }
}
